module.exports = __webpack_public_path__ + "img/4-2-1-2-3-preview-Cantonese-Video-e.eaa4d6ec.jpg";